import { useState, useEffect, useRef } from 'react'
import { supabase } from '../supabase'
import { useToast } from '../hooks/useToast'

function whatsappUrl(telefone) {
  const digits = (telefone || '').replace(/\D/g, '')
  const number = digits.startsWith('55') ? digits : '55' + digits
  return `https://wa.me/${number}`
}

export default function Itens() {
  const [itens, setItens] = useState([])
  const [categorias, setCategorias] = useState([])
  const [fornecedores, setFornecedores] = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [editItem, setEditItem] = useState(null)
  const [form, setForm] = useState({ nome: '', categoria: '', custo: '', unidade: 'unidade', margem: 10, estoque: '', movimenta_estoque: true })
  const [fotoFile, setFotoFile] = useState(null)
  const [fotoPreview, setFotoPreview] = useState(null)
  const [saving, setSaving] = useState(false)
  const [busca, setBusca] = useState('')
  const [filtrocat, setFiltrocat] = useState('')
  const [baixaItem, setBaixaItem] = useState(null)
  const [baixaQty, setBaixaQty] = useState('')
  const [baixaMotivo, setBaixaMotivo] = useState('')
  const [baixaSaving, setBaixaSaving] = useState(false)
  const fotoInputRef = useRef(null)
  const { msg, visible, show } = useToast()

  const [itemFornecedores, setItemFornecedores] = useState([])
  const [addingForn, setAddingForn] = useState(false)
  const [fornForm, setFornForm] = useState({ fornecedor_id: '', custo: '', link_compra: '' })
  const [editFornRow, setEditFornRow] = useState(null)

  useEffect(() => { fetchTudo() }, [])

  async function fetchTudo() {
    setLoading(true)
    const [{ data: itensData }, { data: catsData }, { data: fornData }] = await Promise.all([
      supabase.from('itens').select('*').order('categoria').order('nome'),
      supabase.from('categorias').select('*').order('nome'),
      supabase.from('fornecedores').select('*').order('nome'),
    ])
    setItens(itensData || [])
    setCategorias(catsData || [])
    setFornecedores(fornData || [])
    setLoading(false)
  }

  async function fetchItemFornecedores(itemId) {
    const { data } = await supabase
      .from('item_fornecedores')
      .select('*, fornecedores(*)')
      .eq('item_id', itemId)
      .order('custo')
    setItemFornecedores(data || [])
  }

  function openForm(item = null) {
    if (item) {
      setForm({
        nome: item.nome,
        categoria: item.categoria,
        custo: item.custo,
        unidade: item.unidade,
        margem: item.margem ?? 10,
        estoque: item.estoque ?? '',
        movimenta_estoque: item.movimenta_estoque !== false,
      })
      setFotoPreview(item.foto_url || null)
      setEditItem(item)
      fetchItemFornecedores(item.id)
    } else {
      setForm({ nome: '', categoria: categorias[0]?.nome || '', custo: '', unidade: 'unidade', margem: 10, estoque: '', movimenta_estoque: true })
      setFotoPreview(null)
      setEditItem(null)
      setItemFornecedores([])
    }
    setFotoFile(null)
    setAddingForn(false)
    setEditFornRow(null)
    setFornForm({ fornecedor_id: '', custo: '', link_compra: '' })
    setShowForm(true)
  }

  function handleFotoChange(e) {
    const file = e.target.files[0]
    if (!file) return
    setFotoFile(file)
    setFotoPreview(URL.createObjectURL(file))
  }

  async function uploadFoto(itemId) {
    if (!fotoFile) return null
    const ext = fotoFile.name.split('.').pop()
    const path = `${itemId}.${ext}`
    const { error } = await supabase.storage.from('itens').upload(path, fotoFile, { upsert: true })
    if (error) { show('Erro ao enviar foto'); return null }
    const { data: { publicUrl } } = supabase.storage.from('itens').getPublicUrl(path)
    return publicUrl
  }

  async function salvar() {
    if (!form.nome.trim() || form.custo === '') { show('Preencha nome e custo'); return }
    if (parseFloat(form.custo) < 0) { show('Custo não pode ser negativo'); return }
    setSaving(true)

    const payload = {
      nome: form.nome.trim(),
      categoria: form.categoria,
      custo: parseFloat(form.custo),
      unidade: form.unidade,
      margem: parseFloat(form.margem) || 10,
      estoque: form.movimenta_estoque && form.estoque !== '' ? parseFloat(form.estoque) : null,
      movimenta_estoque: form.movimenta_estoque,
    }

    if (editItem) {
      const fotoUrl = await uploadFoto(editItem.id)
      if (fotoUrl) payload.foto_url = fotoUrl
      const { error } = await supabase.from('itens').update(payload).eq('id', editItem.id)
      if (error) { console.error(error); show('Erro: ' + error.message); setSaving(false); return }
      show('✅ Item atualizado!')
    } else {
      const { data: novo, error } = await supabase.from('itens').insert([payload]).select().single()
      if (error) { console.error(error); show('Erro: ' + error.message); setSaving(false); return }
      const fotoUrl = await uploadFoto(novo.id)
      if (fotoUrl) await supabase.from('itens').update({ foto_url: fotoUrl }).eq('id', novo.id)
      show('✅ Item cadastrado!')
    }

    setSaving(false)
    setShowForm(false)
    fetchTudo()
  }

  async function deletar(id) {
    if (!window.confirm('Remover este item?')) return
    const { count: emArranjo } = await supabase.from('arranjo_itens').select('*', { count: 'exact', head: true }).eq('item_id', id)
    const { count: emCesto } = await supabase.from('cesto_itens').select('*', { count: 'exact', head: true }).eq('item_id', id)
    if (emArranjo > 0 || emCesto > 0) {
      show('Item em uso em produtos ou cestos — remova lá primeiro')
      return
    }
    const { error } = await supabase.from('itens').delete().eq('id', id)
    if (error) { show('Erro ao remover item'); return }
    show('Item removido')
    fetchTudo()
  }

  async function salvarFornRow() {
    if (!fornForm.fornecedor_id) { show('Selecione um fornecedor'); return }
    if (fornForm.custo === '' || parseFloat(fornForm.custo) < 0) { show('Informe o custo'); return }
    const payload = {
      item_id: editItem.id,
      fornecedor_id: fornForm.fornecedor_id,
      custo: parseFloat(fornForm.custo),
      link_compra: fornForm.link_compra.trim() || null,
    }
    if (editFornRow) {
      await supabase.from('item_fornecedores').update({ custo: payload.custo, link_compra: payload.link_compra }).eq('id', editFornRow.id)
    } else {
      const { error } = await supabase.from('item_fornecedores').insert([payload])
      if (error) { show('Este fornecedor já está vinculado'); return }
    }
    setAddingForn(false)
    setEditFornRow(null)
    setFornForm({ fornecedor_id: '', custo: '', link_compra: '' })
    fetchItemFornecedores(editItem.id)
  }

  async function removerFornRow(id) {
    await supabase.from('item_fornecedores').delete().eq('id', id)
    fetchItemFornecedores(editItem.id)
  }

  function usarCusto(custo) {
    setForm(f => ({ ...f, custo: custo }))
    show('Custo atualizado')
  }

  function abrirAddForn() {
    setEditFornRow(null)
    setFornForm({ fornecedor_id: '', custo: '', link_compra: '' })
    setAddingForn(true)
  }

  function abrirEditForn(row) {
    setEditFornRow(row)
    setFornForm({ fornecedor_id: row.fornecedor_id, custo: row.custo, link_compra: row.link_compra || '' })
    setAddingForn(true)
  }

  function abrirBaixa(item) {
    setBaixaItem(item)
    setBaixaQty('')
    setBaixaMotivo('')
  }

  async function salvarBaixa() {
    const qty = parseFloat(String(baixaQty).replace(',', '.')) || 0
    const estoqueAtual = parseFloat(baixaItem?.estoque || 0)
    const custoAtual = parseFloat(baixaItem?.custo || 0)
    if (!baixaItem) return
    if (baixaItem.movimenta_estoque === false) { show('Este item nao movimenta estoque'); return }
    if (qty <= 0) { show('Informe uma quantidade valida'); return }
    if (qty > estoqueAtual) { show('Quantidade maior que o estoque atual'); return }

    setBaixaSaving(true)
    const novoEstoque = estoqueAtual - qty
    const { error: estoqueError } = await supabase.from('itens').update({ estoque: novoEstoque }).eq('id', baixaItem.id)
    if (estoqueError) {
      show('Erro ao baixar estoque')
      setBaixaSaving(false)
      return
    }

    const { error: movError } = await supabase.from('movimentos').insert([{
      item_id: baixaItem.id,
      tipo: 'inutilizado',
      quantidade: qty,
      custo_unitario: custoAtual,
      motivo: baixaMotivo.trim() || null,
    }])
    if (movError) {
      await supabase.from('itens').update({ estoque: estoqueAtual }).eq('id', baixaItem.id)
      show('Erro ao registrar inutilizacao. Estoque revertido.')
      setBaixaSaving(false)
      return
    }

    show('Estoque baixado como inutilizado')
    setBaixaSaving(false)
    setBaixaItem(null)
    fetchTudo()
  }

  const itensFiltrados = itens.filter(i =>
    i.nome.toLowerCase().includes(busca.toLowerCase()) &&
    (filtrocat === '' || i.categoria === filtrocat)
  )
  const categoriasDosItens = [...new Set(itensFiltrados.map(i => i.categoria))]

  const fornecedoresDisponiveis = fornecedores.filter(f =>
    !itemFornecedores.some(r => r.fornecedor_id === f.id) || (editFornRow && editFornRow.fornecedor_id === f.id)
  )

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h1 className="page-title" style={{ margin: 0 }}>Itens</h1>
        <button className="btn btn-primary btn-sm" onClick={() => openForm()}>+ Novo</button>
      </div>

      <div className="row" style={{ marginBottom: 16 }}>
        <div className="field" style={{ marginBottom: 0 }}>
          <input placeholder="Buscar item..." value={busca} onChange={e => setBusca(e.target.value)} />
        </div>
        <div className="field" style={{ marginBottom: 0 }}>
          <select value={filtrocat} onChange={e => setFiltrocat(e.target.value)}>
            <option value="">Todas</option>
            {categorias.map(c => <option key={c.id} value={c.nome}>{c.nome}</option>)}
          </select>
        </div>
      </div>

      {loading && <div className="spinner">Carregando...</div>}

      {!loading && itens.length === 0 && (
        <div className="empty">
          <div className="empty-icon">🌿</div>
          <p>Nenhum item ainda.<br />Cadastre flores, embalagens e mais.</p>
          <br />
          <button className="btn btn-ghost btn-sm" onClick={() => openForm()}>Cadastrar primeiro item</button>
        </div>
      )}

      {!loading && categoriasDosItens.map(cat => (
        <div key={cat}>
          <div className="section-label">{cat}</div>
          <div className="card" style={{ padding: '4px 16px' }}>
            {itensFiltrados.filter(i => i.categoria === cat).map(item => (
              <div key={item.id} className="list-item">
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  {item.foto_url
                    ? <img src={item.foto_url} alt="" style={{ width: 36, height: 36, borderRadius: 8, objectFit: 'cover', flexShrink: 0 }} />
                    : <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--bg)', flexShrink: 0 }} />
                  }
                  <div>
                    <div className="item-name">
                      {item.nome}
                      {item.movimenta_estoque === false && <span style={{ marginLeft: 6, color: 'var(--text-secondary)', fontWeight: 500 }}>(sem estoque)</span>}
                    </div>
                    <div className="item-sub">
                      por {item.unidade}
                      {item.estoque != null && <span style={{ marginLeft: 8, color: item.estoque <= 3 ? 'var(--pink-dark)' : 'inherit' }}>· estoque: {item.estoque}</span>}
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div className="item-price">R${parseFloat(item.custo).toFixed(2)}</div>
                  {item.movimenta_estoque !== false && (
                    <button className="btn btn-danger btn-sm" onClick={() => abrirBaixa(item)} disabled={!item.estoque || parseFloat(item.estoque) <= 0}>baixar</button>
                  )}
                  <button className="btn btn-ghost btn-sm" onClick={() => openForm(item)}>editar</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {showForm && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowForm(false)}>
          <div className="modal">
            <div className="modal-handle" />
            <div className="modal-title">{editItem ? 'Editar item' : 'Novo item'}</div>

            {/* Foto */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <div
                onClick={() => fotoInputRef.current.click()}
                style={{
                  width: 72, height: 72, borderRadius: 12, flexShrink: 0,
                  background: 'var(--bg)', border: '1px dashed var(--border)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer', overflow: 'hidden',
                }}
              >
                {fotoPreview
                  ? <img src={fotoPreview} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  : <span style={{ fontSize: 24 }}>📷</span>
                }
              </div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 2 }}>Foto do item</div>
                <button className="btn btn-ghost btn-sm" onClick={() => fotoInputRef.current.click()}>
                  {fotoPreview ? 'Trocar foto' : 'Adicionar foto'}
                </button>
              </div>
              <input ref={fotoInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFotoChange} />
            </div>

            <div className="field">
              <label>Nome</label>
              <input
                placeholder="Ex: Rosa vermelha, Papel kraft..."
                value={form.nome}
                onChange={e => setForm({ ...form, nome: e.target.value })}
              />
            </div>

            <div className="row">
              <div className="field">
                <label>Categoria</label>
                <select value={form.categoria} onChange={e => setForm({ ...form, categoria: e.target.value })}>
                  {categorias.map(c => <option key={c.id}>{c.nome}</option>)}
                </select>
              </div>
              <div className="field">
                <label>Unidade</label>
                <select value={form.unidade} onChange={e => setForm({ ...form, unidade: e.target.value })}>
                  <option value="unidade">unidade</option>
                  <option value="maço">maço</option>
                  <option value="haste">haste</option>
                  <option value="metro">metro</option>
                  <option value="rolo">rolo</option>
                  <option value="pacote">pacote</option>
                </select>
              </div>
            </div>

            <div className="row">
              <div className="field">
                <label>Custo (R$)</label>
                <input
                  type="number" min="0" step="0.01" placeholder="0,00"
                  value={form.custo}
                  onChange={e => setForm({ ...form, custo: e.target.value })}
                />
              </div>
              <div className="field">
                <label>Margem mão de obra (%)</label>
                <input
                  type="number" min="0" max="100" step="1" placeholder="10"
                  value={form.margem}
                  onChange={e => setForm({ ...form, margem: e.target.value })}
                />
              </div>
            </div>

            <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14, fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)' }}>
              <input
                type="checkbox"
                checked={form.movimenta_estoque}
                onChange={e => setForm({ ...form, movimenta_estoque: e.target.checked, estoque: e.target.checked ? form.estoque : '' })}
                style={{ width: 18, height: 18, accentColor: 'var(--pink)' }}
              />
              Movimenta estoque
            </label>

            {form.movimenta_estoque && <div className="field">
              <label>Estoque atual</label>
              <input
                type="text"
                value={form.estoque !== '' && form.estoque != null ? form.estoque : '—'}
                readOnly
                style={{ background: 'var(--bg)', color: 'var(--text-secondary)', cursor: 'default' }}
              />
              <div style={{ fontSize: 11, color: 'var(--text-secondary)', marginTop: 4 }}>
                Controlado via Entradas
              </div>
            </div>}

            {/* Fornecedores */}
            {editItem && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <label style={{ fontWeight: 600, fontSize: 13, color: 'var(--text-secondary)' }}>Fornecedores</label>
                  {!addingForn && fornecedoresDisponiveis.length > 0 && (
                    <button className="btn btn-ghost btn-sm" onClick={abrirAddForn}>+ adicionar</button>
                  )}
                </div>

                {itemFornecedores.length === 0 && !addingForn && (
                  <div style={{ fontSize: 13, color: 'var(--text-secondary)', fontStyle: 'italic', marginBottom: 8 }}>
                    Nenhum fornecedor vinculado
                  </div>
                )}

                {itemFornecedores.map(row => (
                  <div key={row.id} style={{
                    background: 'var(--bg)', borderRadius: 8, padding: '8px 12px',
                    marginBottom: 6, display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                  }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>{row.fornecedores?.nome}</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2 }}>
                        <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>R${parseFloat(row.custo).toFixed(2)}</div>
                        {row.link_compra && (
                          <a href={row.link_compra} target="_blank" rel="noopener noreferrer"
                            style={{ fontSize: 16, textDecoration: 'none', lineHeight: 1 }}>🔗</a>
                        )}
                        {row.fornecedores?.telefone && (
                          <a href={whatsappUrl(row.fornecedores.telefone)} target="_blank" rel="noopener noreferrer"
                            style={{ fontSize: 16, textDecoration: 'none', lineHeight: 1 }}>💬</a>
                        )}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-ghost btn-sm" onClick={() => usarCusto(row.custo)}>usar custo</button>
                      <button className="btn btn-ghost btn-sm" onClick={() => abrirEditForn(row)}>editar</button>
                      <button className="btn btn-danger btn-sm" onClick={() => removerFornRow(row.id)}>×</button>
                    </div>
                  </div>
                ))}

                {addingForn && (
                  <div style={{ background: 'var(--bg)', borderRadius: 8, padding: 12, marginBottom: 8 }}>
                    <div className="field" style={{ marginBottom: 8 }}>
                      <label>Fornecedor</label>
                      <select
                        value={fornForm.fornecedor_id}
                        onChange={e => setFornForm({ ...fornForm, fornecedor_id: e.target.value })}
                        disabled={!!editFornRow}
                      >
                        <option value="">— selecione —</option>
                        {editFornRow
                          ? fornecedores.filter(f => f.id === editFornRow.fornecedor_id).map(f => <option key={f.id} value={f.id}>{f.nome}</option>)
                          : fornecedoresDisponiveis.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)
                        }
                      </select>
                    </div>
                    <div className="row" style={{ marginBottom: 8 }}>
                      <div className="field" style={{ marginBottom: 0 }}>
                        <label>Custo (R$)</label>
                        <input
                          type="number" min="0" step="0.01" placeholder="0,00"
                          value={fornForm.custo}
                          onChange={e => setFornForm({ ...fornForm, custo: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="field" style={{ marginBottom: 8 }}>
                      <label>Link de compra (opcional)</label>
                      <input
                        placeholder="https://..."
                        value={fornForm.link_compra}
                        onChange={e => setFornForm({ ...fornForm, link_compra: e.target.value })}
                      />
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button className="btn btn-ghost btn-sm" style={{ flex: 1 }} onClick={() => { setAddingForn(false); setEditFornRow(null) }}>Cancelar</button>
                      <button className="btn btn-primary btn-sm" style={{ flex: 1 }} onClick={salvarFornRow}>
                        {editFornRow ? 'Salvar' : 'Vincular'}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}

            <button className="btn btn-primary" onClick={salvar} disabled={saving}>
              {saving ? 'Salvando...' : editItem ? 'Salvar alterações' : 'Cadastrar item'}
            </button>

            {editItem && (
              <button className="btn btn-danger" style={{ marginTop: 8 }} onClick={() => { deletar(editItem.id); setShowForm(false) }}>
                Remover item
              </button>
            )}
          </div>
        </div>
      )}

      {baixaItem && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setBaixaItem(null)}>
          <div className="modal">
            <div className="modal-handle" />
            <div className="modal-title">Produto inutilizado</div>

            <div style={{ background: '#fce4ec', borderRadius: 8, padding: '10px 12px', marginBottom: 14 }}>
              <div style={{ fontSize: 14, fontWeight: 700 }}>{baixaItem.nome}</div>
              <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }}>
                estoque atual: {baixaItem.estoque ?? 0} {baixaItem.unidade} · custo R${parseFloat(baixaItem.custo || 0).toFixed(2)}
              </div>
            </div>

            <div className="field">
              <label>Quantidade inutilizada</label>
              <input
                type="text"
                inputMode="decimal"
                placeholder="0"
                value={baixaQty}
                onChange={e => setBaixaQty(e.target.value)}
                autoFocus
              />
            </div>

            <div className="field">
              <label>Motivo</label>
              <input
                placeholder="Ex: murcho, quebrado, vencido..."
                value={baixaMotivo}
                onChange={e => setBaixaMotivo(e.target.value)}
              />
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setBaixaItem(null)}>Cancelar</button>
              <button className="btn btn-danger" style={{ flex: 2 }} onClick={salvarBaixa} disabled={baixaSaving}>
                {baixaSaving ? 'Baixando...' : 'Baixar estoque'}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`toast ${visible ? 'show' : ''}`}>{msg}</div>
    </div>
  )
}
